import { render } from "./UserTable.vue?vue&type=template&id=fdf5f236&scoped=true"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"

import "./UserTable.vue?vue&type=style&index=0&id=fdf5f236&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf5f236"]])

export default __exports__